import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after 1 second delay
      setTimeout(() => {
        setShowConsent(true);
      }, 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm pointer-events-none">
      <div className="pointer-events-auto animate-in slide-in-from-bottom duration-500">
        <div className="bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
          {/* Compact Header */}
          <div className="bg-blue-900 px-4 py-2 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Cookie className="w-4 h-4 text-white" />
              <h3 className="text-sm font-semibold text-white">Cookie Notice</h3>
            </div>
            <button
              onClick={declineCookies}
              className="text-white/80 hover:text-white transition-colors"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {/* Compact Content */}
          <div className="px-4 py-3">
            <p className="text-sm text-gray-700 mb-3 leading-snug">
              We use cookies to improve your experience.{' '}
              <Link to="/privacy" className="text-blue-900 hover:underline font-medium">
                Learn more
              </Link>
            </p>

            {/* Compact Buttons */}
            <div className="flex gap-2">
              <Button
                onClick={acceptCookies}
                size="sm"
                className="bg-blue-900 hover:bg-blue-800 text-white flex-1 text-sm"
              >
                Accept
              </Button>
              <Button
                onClick={declineCookies}
                size="sm"
                variant="outline"
                className="border border-gray-300 hover:bg-gray-100 text-gray-700 flex-1 text-sm"
              >
                Decline
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;